function smoothScrolling() {
	const allHashes = document.querySelectorAll(
		'a[href^="#"]:not([href="#"], a[href*=".html#"]'
	);

	const hash = window.location.hash;

	if (!hash && !allHashes.length) return;

	if (hash) {
		const targetEl = document.querySelector(hash);
		if (!targetEl) return;
		scrolllll(targetEl);
	}

	if (allHashes.length) {
		allHashes.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const href = el.getAttribute('href');
				const targetEl = document.querySelector(href);
				if (!targetEl) return;
				scrolllll(targetEl);
			});
		});
	}
}

function scrolllll(targetEl) {
	setTimeout(() => {
		targetEl.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
	}, 100);
}

export default smoothScrolling;
